// Fields to Inventory Information
export default [
    {
        //inventory fields[0] - Stock mínimo
        field: 'minimum_stock',
        type: 'text',
        vuetifyProps: {
            label: 'Mínimo Stock',
            mask: '########',
        },
        rules: ['required'],
    },
    {
        //inventory fields[1] - Stock máximo
        field: 'maximum_stock',
        type: 'text',
        vuetifyProps: {
            label: 'Máximo Stock',
            mask: '########',
        },
        rules: ['required'],
    },
    {
        //inventory fields[2] - Stock crítico
        field: 'critical_stock',
        type: 'text',
        vuetifyProps: {
            label: 'Stock Crítico',
            mask: '########',
        },
        rules: ['required'],
    },
    {
        field: 'wh_unit_of_measurement_id',
        type: 'autocompleteObject',
        vuetifyProps: {
            label: 'Unidad de Medida (U.M)',
        },
        options: {
            data: [],
            text: 'name',
            value: 'id',
        },
        rules: ['required'],
    },
    {
        field: 'uom_quantity',
        type: 'text',
        vuetifyProps: {
            label: 'Cantidad Minima (U.M)',
            
        },
        rules: ['required'],
    },
    {
        field:'empty',
        type:'empty',
    },
    {
        field: 'Información Global',
        type: 'section',
    },
    {
        //inventory fields[3] - Cantidad decimal
        field: 'have_decimal_quantity',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Cantidad Decimal',
        },
        value: false,
    },
    {
        //inventory fields[3] - Producto envasado
        field: 'is_repackaged',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Envasado',
        },
        value: false,
    },
    {
        // inventory fields[6] - Producto inventariable
        field: 'is_inventoriable',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Inventariable',
            'false-value': false,
        },
        value: false,
    },
    {
        // inventory fields[7] - Producto de temporada
        field: 'is_seasonal',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Producto Temporada',
            'false-value': false,
        },
        value: false,
    },
]
